module.exports = __webpack_public_path__ + "img/vip-gray-icon.d6105ec0.png";